import { FirmAccessLevelEnum, useCollaborator } from '@melio/platform-api';

export const useHasAccessToFirm = () => {
  const { data: actor } = useCollaborator({ id: 'me' });
  return actor?.firmAccessLevel !== FirmAccessLevelEnum.None;
};
